import { Box, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { headCells } from './MappingTableHeadCells';
import { visuallyHidden } from '@mui/utils';
import { AdminPanelSettings, Person } from "@mui/icons-material";

export default function MappingTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead sx={{backgroundColor: "#cdd1dc"}}>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        //padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {
                            headCell.sortable ?
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={createSortHandler(headCell.id)}
                                >
                                    {headCell.label}
                                    {orderBy === headCell.id ? (
                                        <Box component="span" sx={visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </Box>
                                    ) : null}
                                </TableSortLabel>
                                : <TableSortLabel hideSortIcon>
                                    {headCell.id === "isAdminOnlyAccess" ? <AdminPanelSettings></AdminPanelSettings> : null}
                                    {headCell.id === "isUserAccess" ? <Person></Person> : null}
                                    {headCell.label}
                                </TableSortLabel>
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}